(function () {
  if (!document.body.classList.contains('template-index')) return;
  if (window.__luxoSmoothHeaderScroll) return;
  window.__luxoSmoothHeaderScroll = true;

  var header = document.getElementById('SiteHeader');
  var wrapper = document.getElementById('HeaderWrapper');
  if (!header || !wrapper || header.getAttribute('data-sticky') !== 'true') return;

  var announcement = document.querySelector('.announcement-bar');
  var previousY = window.pageYOffset || 0;
  var hideTimer = null;
  var headerStyle = getComputedStyle(header);
  var paddingTop = headerStyle.paddingTop;
  var paddingBottom = headerStyle.paddingBottom;

  var style = document.createElement('style');
  style.textContent = [
    '.template-index #HeaderWrapper.luxo-scroll-placeholder { min-height: var(--luxo-header-height) !important; }',
    '.template-index #SiteHeader.luxo-scroll-controlled { position: fixed !important; top: var(--luxo-sticky-offset, 0px) !important; left: 0 !important; right: 0 !important; width: 100% !important; z-index: 28 !important; padding-top: var(--luxo-padding-top) !important; padding-bottom: var(--luxo-padding-bottom) !important; transition: transform .8s cubic-bezier(.4,0,.2,1) !important; will-change: transform; }',
    '.template-index #SiteHeader.luxo-scroll-hidden { transform: translateY(calc(-1 * var(--luxo-header-travel))) !important; pointer-events: none !important; }',
    '.template-index #SiteHeader.luxo-scroll-visible { transform: translateY(0) !important; pointer-events: auto !important; }',
    '.template-index .announcement-bar.luxo-scroll-announcement { transition: transform .8s cubic-bezier(.4,0,.2,1) !important; will-change: transform; }',
    '.template-index .announcement-bar.luxo-scroll-announcement.luxo-scroll-hidden { transform: translateY(calc(-1 * var(--luxo-header-travel))) !important; pointer-events: none !important; }',
    '.template-index .announcement-bar.luxo-scroll-announcement.luxo-scroll-visible { transform: translateY(0) !important; }',
    '@media (prefers-reduced-motion: reduce) { .template-index #SiteHeader.luxo-scroll-controlled, .template-index .announcement-bar.luxo-scroll-announcement { transition: none !important; } }'
  ].join('\n');
  document.head.appendChild(style);

  function cancelHide() {
    clearTimeout(hideTimer);
    hideTimer = null;
  }

  function interacting() {
    return document.documentElement.classList.contains('js-drawer-open') ||
      !!header.querySelector('details[open], [aria-expanded="true"], :focus-visible, input:focus');
  }

  function clearControl() {
    cancelHide();
    header.classList.remove('luxo-scroll-controlled', 'luxo-scroll-hidden', 'luxo-scroll-visible');
    wrapper.classList.remove('luxo-scroll-placeholder');
    ['--luxo-header-height', '--luxo-sticky-offset', '--luxo-header-travel', '--luxo-padding-top', '--luxo-padding-bottom'].forEach(function (name) {
      wrapper.style.removeProperty(name);
    });
    if (announcement) {
      announcement.classList.remove('luxo-scroll-announcement', 'luxo-scroll-hidden', 'luxo-scroll-visible');
      announcement.style.removeProperty('--luxo-header-travel');
    }
  }

  function setControl(hidden) {
    wrapper.style.setProperty('--luxo-padding-top', paddingTop);
    wrapper.style.setProperty('--luxo-padding-bottom', paddingBottom);
    header.classList.add('luxo-scroll-controlled');
    var height = header.offsetHeight;
    var offset = announcement && getComputedStyle(announcement).position === 'fixed' ? announcement.offsetHeight : 0;
    var travel = height + offset + 2;
    wrapper.style.setProperty('--luxo-header-height', height + 'px');
    wrapper.style.setProperty('--luxo-sticky-offset', offset + 'px');
    wrapper.style.setProperty('--luxo-header-travel', travel + 'px');
    wrapper.classList.add('luxo-scroll-placeholder');
    header.classList.toggle('luxo-scroll-hidden', hidden);
    header.classList.toggle('luxo-scroll-visible', !hidden);
    if (announcement && offset) {
      announcement.style.setProperty('--luxo-header-travel', travel + 'px');
      announcement.classList.add('luxo-scroll-announcement');
      announcement.classList.toggle('luxo-scroll-hidden', hidden);
      announcement.classList.toggle('luxo-scroll-visible', !hidden);
    }
  }

  function scheduleHide() {
    cancelHide();
    hideTimer = setTimeout(function () {
      hideTimer = null;
      if ((window.pageYOffset || 0) <= 30) return;
      if (interacting()) {
        scheduleHide();
        return;
      }
      setControl(true);
    }, 2000);
  }

  function onScroll() {
    var currentY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var change = currentY - previousY;
    if (currentY <= 30) {
      clearControl();
    } else if (change > 2) {
      cancelHide();
      setControl(!interacting());
      if (interacting()) scheduleHide();
    } else if (change < -2) {
      setControl(false);
      scheduleHide();
    }
    previousY = currentY;
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    if (header.classList.contains('luxo-scroll-controlled')) {
      setControl(header.classList.contains('luxo-scroll-hidden'));
    }
  }, { passive: true });
  header.addEventListener('focusin', function () {
    if ((window.pageYOffset || 0) > 30) {
      setControl(false);
      scheduleHide();
    }
  });
  header.addEventListener('focusout', scheduleHide);
  header.addEventListener('pointerleave', function () {
    if (header.classList.contains('luxo-scroll-visible')) scheduleHide();
  });
  if (previousY > 30) setControl(true);
})();
